import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var ChevronDownSmall = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ChevronDownSmall_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 10,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.663 10.365a.559.559 0 0 1-.038-.037L3.647 6.35a.5.5 0 1 1 .708-.706l3.642 3.642 3.65-3.64a.501.501 0 0 1 .708 0 .499.499 0 0 1 0 .707L8.427 10.27a.502.502 0 0 1-.764.096Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ChevronDownSmall_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default ChevronDownSmall;